import React, { useState } from 'react';
import { Card, Form, Select, Input, Button, Table, Tag, Modal, Descriptions, Divider, Typography, Space, Empty, message, Spin, Row, Col, Cascader } from 'antd';
import { SearchOutlined, EyeOutlined, ReloadOutlined } from '@ant-design/icons';
import {
  ORDER_SOURCE_OPTIONS,
  APP_DIRECTION_OPTIONS,
  ORDER_SOURCE_COLORS,
  APP_DIRECTION_COLORS,
  getOrderSourceLabels,
  getAppDirectionLabels,
  matchOrderSource,
  matchAppDirection,
} from '../../../utils/valueOrderDisplay';

const { Title, Text } = Typography;

/** 逐行 tag 渲染（订单来源 / 应用方向 多字段拼接展示，每行一个 tag） */
const renderTagLines = (labels, colorMap) => {
  if (!labels || labels.length === 0) return <span style={{ color: '#ccc' }}>-</span>;
  return (
    <div>
      {labels.map((label) => (
        <div key={label} style={{ marginBottom: 2 }}>
          <Tag color={colorMap[label] || 'blue'} style={{ border: 'none', marginRight: 4 }}>{label}</Tag>
        </div>
      ))}
    </div>
  );
};

// ══════════════════════════════════════════════
//  Mock 数据：增值服务订单
//  TODO: 联调时替换为接口数据
// ══════════════════════════════════════════════

// 模拟当前登录企业（客服专员视角）
const CURRENT_ENTERPRISE_ID = 'QEBcW6rqyCMIOVUL';
const CURRENT_ENTERPRISE_NAME = '微网优联科技（成都）有限公司';

// DID → License 映射（模拟公共方法的数据源）
// TODO: 联调时替换为接口调用
const DID_LICENSE_MAP = {
  'test-did-01': 'test-license-01',
  'test-did-02': 'test-license-02',
  'test-did-03': 'test-license-03',
  'test-did-04': 'test-license-04',
  'test-did-05': 'test-license-05',
};

const MOCK_ORDERS = [
  {
    key: '1', orderNo: 'test-order-001', status: '已支付',
    orderSource: ['购买', '常规购买'], deviceScope: '单设备',
    createTimeUTC: '2026-02-28 03:20:02', createTimeLocal: '2026-02-28 11:20:02',
    appName: 'U家智联', appPlatform: 'Andriod-国内', appId: 'GFZUm2Tk18zPUFCT',
    appDirection: '设备', paymentMethod: '企业收款',
    appEnterprise: CURRENT_ENTERPRISE_NAME, appEnterpriseId: CURRENT_ENTERPRISE_ID,
    deviceEnterprise: CURRENT_ENTERPRISE_NAME, deviceEnterpriseId: CURRENT_ENTERPRISE_ID,
    productName: 'U-C201D-双目2MP4G云台机--国内版', productId: 'QEBw5aek7qkmiliq',
    license: 'test-license-01', userId: 'test-uid-01',
    userAccount: '13800138000', userRegTime: '2025-06-15',
    payChannel: '微信', payCurrency: '人民币', payAmount: '149.00', payOrderNo: 'test-pay-001',
    bizPayTimeUTC: '2026-02-28 03:20:18', bizPayTimeLocal: '2026-02-28 11:20:18',
    actualPayTimeUTC: '2026-02-28 03:20:18', actualPayTimeLocal: '2026-02-28 11:20:18',
    packageName: '7天循环录像【12个月】', packageId: 'WKfjwcCxUO',
    location: '国内', subscriptionType: '非订阅', duration: '12个月',
    isFirstSubscription: '是', isTrial: '是', trialDays: 7,
    packageStatus: '生效中', packagePrice: '¥ 149.00',
    appleInAppKey: '-', googleInAppKey: '-',
    serviceType: '事件云存储', serviceName: '7天事件模板-12个月', serviceId: '12', serviceDuration: '12月',
    serviceFloorPrice: '50.0元, 10.0美元',
    packageServices: [
      { serviceType: '全天云存', serviceName: '全天云存-标清版', serviceId: 'SVC001', platformCost: '¥ 15.00，$ 2.20' },
      { serviceType: '鸟类识别', serviceName: 'AI鸟类智能识别', serviceId: 'SVC002', platformCost: '¥ 5.00，$ 0.20' },
    ],
    refundMethod: '-', refundCurrency: '-', refundAmount: '0.00',
    refundTimeUTC: '-', refundTimeLocal: '-',
    relatedOrders: [
      { key: 'r1', orderNo: 'REL-20260228-101', status: '已支付', payTimeUtc: '2026-02-28 03:25:00', payCurrency: '人民币', payAmount: '149.00', subscriptionType: '非订阅', createTimeUtc: '2026-02-28 03:20:00' },
    ],
  },
  {
    key: '2', orderNo: 'test-order-002', status: '已全额退款',
    orderSource: ['购买', '常规购买'],
    createTimeUTC: '2026-02-28 04:55:12', createTimeLocal: '2026-02-28 12:55:12',
    appName: 'U家智联', appPlatform: 'iOS-国内', appId: 'AFZUm2Tk18zPUFXX',
    appDirection: '用户', paymentMethod: '企业收款',
    appEnterprise: '某电子科技有限公司', appEnterpriseId: 'QEBcW6rqyCMIO001',
    deviceEnterprise: '某电子科技有限公司', deviceEnterpriseId: 'QEBcW6rqyCMIO001',
    productName: '智能摄像机 Q1', productId: 'PROD_001',
    license: 'test-license-02', userId: 'test-uid-02',
    userAccount: 'test@example.com', userRegTime: '2025-01-01',
    payChannel: '支付宝', payCurrency: '人民币', payAmount: '299.00', payOrderNo: 'test-pay-002',
    bizPayTimeUTC: '2026-02-28 04:56:00', bizPayTimeLocal: '2026-02-28 12:56:00',
    actualPayTimeUTC: '2026-02-28 04:56:00', actualPayTimeLocal: '2026-02-28 12:56:00',
    packageName: '30天不间断录像【1个月】', packageId: 'PKG_30D_1M',
    location: '国内', subscriptionType: '订阅制', duration: '1个月',
    isFirstSubscription: '否', isTrial: '是', trialDays: 3,
    packageStatus: '已失效', subscriptionPrice: '¥ 299.00',
    appleInAppKey: '-', googleInAppKey: '-',
    serviceType: '全时云存储', serviceName: '30天全时模板-1个月', serviceId: '22', serviceDuration: '1月',
    serviceFloorPrice: '100.0元',
    packageServices: [
      { serviceType: '全时云存', serviceName: '全时云存-高清版', serviceId: 'SVC003', platformCost: '¥ 25.00，$ 3.50' },
    ],
    refundMethod: '支付宝', refundCurrency: 'CNY', refundAmount: '299.00',
    refundTimeUTC: '2026-02-28 05:10:00', refundTimeLocal: '2026-02-28 13:10:00',
    relatedOrders: [
      { key: 'r1', orderNo: 'REL-20260228-201', status: '已支付', payTimeUtc: '2026-02-28 04:56:00', payCurrency: '人民币', payAmount: '299.00', subscriptionType: '订阅制', createTimeUtc: '2026-02-28 04:55:00' },
    ],
  },
  {
    key: '3', orderNo: 'test-order-003', status: '已部分退款',
    orderSource: ['赠送'], deviceScope: '多设备',
    createTimeUTC: '2026-02-28 06:12:44', createTimeLocal: '2026-02-28 14:12:44',
    appName: 'U家智联', appPlatform: 'Andriod-海外', appId: 'GFZUm2Tk18zPUFCT',
    appDirection: '设备', paymentMethod: '平台收款',
    appEnterprise: '智慧家居有限公司', appEnterpriseId: 'QEBcW6rqyCMIO999',
    deviceEnterprise: CURRENT_ENTERPRISE_NAME, deviceEnterpriseId: CURRENT_ENTERPRISE_ID,
    productName: '户外防水机 W2', productId: 'PROD_W2',
    license: 'test-license-03', userId: 'test-uid-03',
    userAccount: '13900139000', userRegTime: '2025-10-10',
    payChannel: 'Paypal', payCurrency: '美元', payAmount: '29.99', payOrderNo: 'test-pay-003',
    bizPayTimeUTC: '2026-02-28 06:15:00', bizPayTimeLocal: '2026-02-28 14:15:00',
    actualPayTimeUTC: '2026-02-28 06:15:00', actualPayTimeLocal: '2026-02-28 14:15:00',
    packageName: '7天循环录像【6个月】', packageId: 'PKG_7D_6M',
    location: '海外', subscriptionType: '非订阅', duration: '6个月',
    isFirstSubscription: '是', isTrial: '否',
    packageStatus: '待生效', packagePrice: '$ 29.90',
    appleInAppKey: '-', googleInAppKey: '-',
    serviceType: '事件云存储', serviceName: '7天事件模板-6个月', serviceId: '13', serviceDuration: '6月',
    serviceFloorPrice: '60.0元',
    packageServices: [
      { serviceType: '事件云存', serviceName: '事件云存-标清版', serviceId: 'SVC004', platformCost: '¥ 10.00，$ 1.50' },
    ],
    refundMethod: 'Paypal', refundCurrency: 'USD', refundAmount: '5.00',
    refundTimeUTC: '2026-02-28 07:00:00', refundTimeLocal: '2026-02-28 15:00:00',
    relatedOrders: [],
  },
  {
    key: '4', orderNo: 'test-order-004', status: '已支付',
    orderSource: ['购买', '活动专享', '单次解锁事件记录'], deviceScope: '单设备',
    createTimeUTC: '2026-02-28 08:00:00', createTimeLocal: '2026-02-28 16:00:00',
    appName: 'U家智联', appPlatform: 'iOS-全球通用', appId: 'GFZUm2Tk18zPUFCT',
    appDirection: '设备', paymentMethod: '企业收款',
    appEnterprise: CURRENT_ENTERPRISE_NAME, appEnterpriseId: CURRENT_ENTERPRISE_ID,
    deviceEnterprise: '某电子科技有限公司', deviceEnterpriseId: 'QEBcW6rqyCMIO001',
    productName: '双目室外机', productId: 'QEBw5aek7q',
    license: 'test-license-04', userId: 'test-uid-04',
    userAccount: '-', userRegTime: '-',
    payChannel: 'ApplePay', payCurrency: '美元', payAmount: '12.99', payOrderNo: 'test-pay-004',
    bizPayTimeUTC: '2026-02-28 08:05:00', bizPayTimeLocal: '2026-02-28 16:05:00',
    actualPayTimeUTC: '2026-02-28 08:05:00', actualPayTimeLocal: '2026-02-28 16:05:00',
    packageName: '3天循环录像【1个月】', packageId: 'PKG_3D_1M',
    location: '全球', subscriptionType: '订阅制', duration: '1个月',
    isFirstSubscription: '是', isTrial: '是', trialDays: 3,
    packageStatus: '生效中', subscriptionPrice: '¥ 88.00，$ 10.00',
    appleInAppKey: 'apple.sub.3d.1m', googleInAppKey: 'google.sub.3d.1m',
    serviceType: '事件云存储', serviceName: '3天事件模板-1个月', serviceId: '11', serviceDuration: '1月',
    serviceFloorPrice: '20.0元',
    packageServices: [
      { serviceType: '事件云存', serviceName: '事件云存-标清版', serviceId: 'SVC005', platformCost: '¥ 8.00，$ 1.20' },
      { serviceType: '人脸识别', serviceName: 'AI人脸识别', serviceId: 'SVC006', platformCost: '¥ 3.00，$ 0.50' },
    ],
    refundMethod: '-', refundCurrency: '-', refundAmount: '0.00',
    refundTimeUTC: '-', refundTimeLocal: '-',
    relatedOrders: [
      { key: 'r1', orderNo: 'REL-20260228-401', status: '已支付', payTimeUtc: '2026-02-28 08:10:00', payCurrency: '美元', payAmount: '12.99', subscriptionType: '订阅制', createTimeUtc: '2026-02-28 08:05:00' },
    ],
  },
  {
    key: '5', orderNo: 'test-order-005', status: '已支付',
    orderSource: ['购买', '常规购买'], deviceScope: '单设备',
    createTimeUTC: '2026-03-01 12:00:00', createTimeLocal: '2026-03-01 20:00:00',
    appName: '智慧看家', appPlatform: 'Andriod-国内', appId: 'AP00000001',
    appDirection: '设备', paymentMethod: '平台收款',
    appEnterprise: CURRENT_ENTERPRISE_NAME, appEnterpriseId: CURRENT_ENTERPRISE_ID,
    deviceEnterprise: CURRENT_ENTERPRISE_NAME, deviceEnterpriseId: CURRENT_ENTERPRISE_ID,
    productName: '智能门铃 Pro', productId: 'PROD_DB01',
    license: 'test-license-05', userId: 'test-uid-05',
    userAccount: '13600136000', userRegTime: '2026-01-20',
    payChannel: '微信', payCurrency: '人民币', payAmount: '199.00', payOrderNo: 'test-pay-005',
    bizPayTimeUTC: '2026-03-01 12:05:00', bizPayTimeLocal: '2026-03-01 20:05:00',
    actualPayTimeUTC: '2026-03-01 12:05:00', actualPayTimeLocal: '2026-03-01 20:05:00',
    packageName: '全天云存【年度版】', packageId: 'PKG_CLOUD_Y',
    location: '国内', subscriptionType: '非订阅', duration: '12个月',
    isFirstSubscription: '是', isTrial: '否',
    packageStatus: '生效中', packagePrice: '¥ 199.00',
    appleInAppKey: '-', googleInAppKey: '-',
    serviceType: '全天云存', serviceName: '全天云存-年度版', serviceId: '30', serviceDuration: '12月',
    serviceFloorPrice: '80.0元',
    packageServices: [
      { serviceType: '全天云存', serviceName: '全天云存-高清版', serviceId: 'SVC007', platformCost: '¥ 30.00' },
      { serviceType: 'AI识别', serviceName: 'AI人形检测', serviceId: 'SVC008', platformCost: '¥ 10.00' },
    ],
    refundMethod: '-', refundCurrency: '-', refundAmount: '0.00',
    refundTimeUTC: '-', refundTimeLocal: '-',
    relatedOrders: [],
  },
];

// ══════════════════════════════════════════════
//  辅助函数
// ══════════════════════════════════════════════

/** DID→License 转换（模拟公共方法） */
const convertDidToLicense = (did) => {
  return DID_LICENSE_MAP[did] || null;
};

/** 状态 → 颜色映射 */
const getStatusColor = (status) => {
  const map = {
    '已支付': 'green',
    '已全额退款': 'default',
    '已部分退款': 'orange',
    '申请退款中': 'red',
    '已作废': 'default',
  };
  return map[status] || 'blue';
};

/** 查询类型选项 */
const QUERY_TYPES = [
  { value: 'orderNo', label: '订单号' },
  { value: 'did', label: '设备DID' },
  { value: 'license', label: 'License' },
  { value: 'uid', label: '用户UID' },
  { value: 'payOrderNo', label: '支付单号' },
];

/** 查询类型 → 占位文案 */
const PLACEHOLDER_MAP = {
  orderNo: '请输入订单号',
  did: '请输入设备DID',
  license: '请输入License码',
  uid: '请输入用户UID',
  payOrderNo: '请输入支付单号',
};

// ══════════════════════════════════════════════
//  主组件
// ══════════════════════════════════════════════

const OrderQuery = () => {
  const [form] = Form.useForm();
  const [queryType, setQueryType] = useState('orderNo');
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [results, setResults] = useState([]);
  const [detailVisible, setDetailVisible] = useState(false);
  const [currentOrder, setCurrentOrder] = useState(null);

  // 模拟角色切换（便于原型演示）
  // TODO: 联调时通过登录态获取真实角色
  const [roleMode, setRoleMode] = useState('cs'); // 'cs' | 'platform'

  const isPlatform = roleMode === 'platform';

  // ═══════════ 查询处理 ═══════════
  const handleSearch = () => {
    form.validateFields().then((values) => {
      const keyword = (values.keyword || '').trim();
      if (!keyword) {
        message.warning('请输入查询关键字');
        return;
      }
      if (keyword.length > 200) {
        message.warning('输入内容过长，请核对');
        return;
      }

      setLoading(true);
      setSearched(true);

      // 模拟异步查询
      setTimeout(() => {
        let searchValue = keyword;
        let searchField = queryType;
        const orderSourceFilter = values.orderSource;
        const appDirectionFilter = values.appDirection;

        // DID → License 转换
        if (queryType === 'did') {
          const license = convertDidToLicense(keyword);
          if (!license) {
            setLoading(false);
            setResults([]);
            message.warning('未找到该DID对应的设备');
            return;
          }
          searchValue = license;
          searchField = 'license';
        }

        // 按查询类型+关键字搜索
        let matched = MOCK_ORDERS.filter((order) => {
          const fieldMap = {
            orderNo: order.orderNo,
            license: order.license,
            uid: order.userId,
            payOrderNo: order.payOrderNo,
          };
          const fieldValue = fieldMap[searchField];
          return fieldValue && fieldValue.toLowerCase().includes(searchValue.toLowerCase());
        });

        // 订单来源 / 应用方向 级联筛选（「全部」等于不选择）
        matched = matched.filter((order) => matchOrderSource(order.orderSource, orderSourceFilter));
        matched = matched.filter((order) => matchAppDirection(order, appDirectionFilter));

        // 企业角色：按数据范围过滤（按查询类型区分匹配规则）
        if (!isPlatform) {
          if (searchField === 'uid') {
            // UID：仅 App 企业（UID 属于 App 用户域，设备企业无从知晓）
            matched = matched.filter(order =>
              order.appEnterpriseId === CURRENT_ENTERPRISE_ID
            );
          } else {
            // 订单号 / DID / License：App企业 或 设备企业 任一匹配即可
            matched = matched.filter(order =>
              order.appEnterpriseId === CURRENT_ENTERPRISE_ID ||
              order.deviceEnterpriseId === CURRENT_ENTERPRISE_ID
            );
          }
        }

        // 按创建时间倒序
        matched.sort((a, b) => b.createTimeUTC.localeCompare(a.createTimeUTC));

        setResults(matched);
        setLoading(false);
      }, 600);
    }).catch(() => {
      // 校验不通过时表单已展示错误提示，无需额外处理
    });
  };

  // ═══════════ 查询类型切换 ═══════════
  const handleTypeChange = (value) => {
    setQueryType(value);
    form.setFieldValue('keyword', '');
  };

  // ═══════════ 详情弹窗 ═══════════
  const showDetail = (record) => {
    setCurrentOrder(record);
    setDetailVisible(true);
  };

  // ═══════════ 列表列定义 ═══════════
  const getColumns = () => {
    const baseColumns = [
      {
        title: '订单编号', dataIndex: 'orderNo', key: 'orderNo',
        width: 220, fixed: 'left',
        render: (text) => <Text copyable style={{ fontFamily: 'monospace', fontSize: 12 }}>{text}</Text>,
      },
      {
        title: '订单状态', dataIndex: 'status', key: 'status', width: 110,
        render: (status) => <Tag color={getStatusColor(status)} bordered={false}>{status}</Tag>,
      },
      {
        title: '订单来源', dataIndex: 'orderSource', key: 'orderSource', width: 150,
        render: (orderSource) => renderTagLines(getOrderSourceLabels(orderSource), ORDER_SOURCE_COLORS),
      },
      {
        title: '应用方向', key: 'appDirection', width: 110,
        render: (_, record) => renderTagLines(getAppDirectionLabels(record), APP_DIRECTION_COLORS),
      },
      {
        title: '应用信息', key: 'appInfo', width: 170,
        render: (_, record) => (
          <div style={{ fontSize: 12 }}>
            <div style={{ fontWeight: 500 }}>{record.appName}</div>
            <div style={{ color: '#999' }}>{record.appPlatform}</div>
          </div>
        ),
      },
      {
        title: '产品信息', key: 'productInfo', width: 170,
        render: (_, record) => (
          <div style={{ fontSize: 12 }}>
            <div style={{ fontWeight: 500 }}>{record.productName}</div>
            <div style={{ color: '#999' }}>ID: {record.productId}</div>
          </div>
        ),
      },
    ];

    // 平台运营：额外展示「所属企业」列
    if (isPlatform) {
      baseColumns.push({
        title: '所属企业', key: 'ownerEnterprise', width: 190,
        render: (_, record) => (
          <div style={{ fontSize: 12 }}>
            <div style={{ fontWeight: 500 }}>{record.appEnterprise}</div>
            <div style={{ color: '#999' }}>ID: {record.appEnterpriseId}</div>
          </div>
        ),
      });
    }

    baseColumns.push(
      {
        title: 'License', dataIndex: 'license', key: 'license', width: 160,
        render: (text) => <Text style={{ fontFamily: 'monospace', fontSize: 12 }}>{text || '-'}</Text>,
      },
      {
        title: '用户ID', dataIndex: 'userId', key: 'userId', width: 160,
        render: (text) => <Text copyable style={{ fontFamily: 'monospace', fontSize: 11 }}>{text || '-'}</Text>,
      },
      {
        title: '支付信息', key: 'payInfo', width: 130,
        render: (_, record) => (
          <div style={{ fontSize: 12 }}>
            <div>{record.payChannel}</div>
            <div><Text strong>{record.payCurrency === '人民币' ? '¥' : '$'}{record.payAmount}</Text></div>
          </div>
        ),
      },
      {
        title: '支付单号', dataIndex: 'payOrderNo', key: 'payOrderNo', width: 200,
        render: (text) => <Text style={{ fontFamily: 'monospace', fontSize: 11 }}>{text || '-'}</Text>,
      },
      {
        title: '套餐信息', dataIndex: 'packageName', key: 'packageName', width: 170,
        ellipsis: { showTitle: false },
        render: (text) => <Text style={{ fontSize: 12 }}>{text || '-'}</Text>,
      },
      {
        title: '创建时间', key: 'createTime', width: 170,
        render: (_, record) => (
          <div style={{ fontSize: 12 }}>
            <div>{record.createTimeLocal}</div>
            <div style={{ color: '#999', fontSize: 11 }}>{record.createTimeUTC} (UTC)</div>
          </div>
        ),
      },
      {
        title: '操作', key: 'action', fixed: 'right', width: 100, align: 'center',
        render: (_, record) => (
          <Button type="link" size="small" icon={<EyeOutlined />} onClick={() => showDetail(record)}>
            查看详情
          </Button>
        ),
      },
    );

    return baseColumns;
  };

  // ═══════════ 渲染 ═══════════
  return (
    <div style={{ padding: 24 }}>
      {/* 标题区 */}
      <div style={{ marginBottom: 16 }}>
        <Title level={4} style={{ marginBottom: 4 }}>增值订单查询</Title>
        <Text type="secondary" style={{ fontSize: 13 }}>
          通过订单号、设备DID、License、用户UID或支付单号快速定位订单
        </Text>
      </div>

      {/* 角色切换（仅原型演示用） */}
      <Card size="small" style={{ marginBottom: 16, borderRadius: 12, background: '#fafafa' }}>
        <Row align="middle" justify="space-between">
          <Col>
            <Text type="secondary" style={{ fontSize: 12 }}>
              🔧 原型演示：当前角色为 <Text strong>{isPlatform ? '平台运营' : '客服专员'}</Text>
              （{isPlatform ? '全平台数据' : `企业: ${CURRENT_ENTERPRISE_NAME}`}）
            </Text>
          </Col>
          <Col>
            <Button size="small" onClick={() => { setRoleMode(isPlatform ? 'cs' : 'platform'); setResults([]); setSearched(false); }}>
              切换为{isPlatform ? '客服专员' : '平台运营'}
            </Button>
          </Col>
        </Row>
      </Card>

      {/* 查询条件区 */}
      <Card bordered={false} style={{ marginBottom: 8, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
        <Form form={form} layout="inline" style={{ flexWrap: 'wrap', rowGap: 8 }}>
          <Form.Item name="queryType" initialValue="orderNo" style={{ marginBottom: 0 }}>
            <Select
              value={queryType}
              onChange={handleTypeChange}
              style={{ width: 120 }}
              options={QUERY_TYPES}
            />
          </Form.Item>
          <Form.Item
            name="keyword"
            style={{ flex: 1, marginBottom: 0 }}
            rules={[{ required: true, message: '请输入查询关键字' }]}
          >
            <Input
              placeholder={PLACEHOLDER_MAP[queryType]}
              style={{ minWidth: 320 }}
              maxLength={200}
              allowClear
              onPressEnter={handleSearch}
            />
          </Form.Item>
          <Form.Item name="orderSource" style={{ marginBottom: 0 }}>
            <Cascader options={ORDER_SOURCE_OPTIONS} placeholder="订单来源" allowClear style={{ width: 190 }} />
          </Form.Item>
          <Form.Item name="appDirection" style={{ marginBottom: 0 }}>
            <Cascader options={APP_DIRECTION_OPTIONS} placeholder="应用方向" allowClear style={{ width: 160 }} />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Space>
              <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch} loading={loading}>
                查询
              </Button>
              <Button icon={<ReloadOutlined />} onClick={() => { form.resetFields(); setResults([]); setSearched(false); }}>
                重置
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>

      {/* 结果摘要区 */}
      {searched && !loading && (
        <div style={{ marginBottom: 8, padding: '0 4px' }}>
          <Text type="secondary" style={{ fontSize: 13 }}>本次查询匹配 <Text strong>{results.length}</Text> 条记录</Text>
        </div>
      )}

      {/* 结果列表区 */}
      <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
        {!searched ? (
          <Empty
            description="请选择查询类型并输入关键字后点击查询"
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            style={{ padding: '60px 0' }}
          />
        ) : loading ? (
          <div style={{ textAlign: 'center', padding: '60px 0' }}>
            <Spin size="large" tip="正在查询..." />
          </div>
        ) : results.length === 0 ? (
          <Empty
            description="未查询到相关订单，请核对查询条件"
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            style={{ padding: '60px 0' }}
          />
        ) : (
          <Table
            columns={getColumns()}
            dataSource={results}
            scroll={{ x: isPlatform ? 1980 : 1730 }}
            bordered={false}
            pagination={{
              pageSize: 20,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50', '100'],
              showTotal: (total) => `共 ${total} 条记录`,
            }}
            rowKey="key"
            size="middle"
          />
        )}
      </Card>

      {/* 订单详情弹窗 */}
      <Modal
        title="订单详情"
        open={detailVisible}
        onCancel={() => setDetailVisible(false)}
        footer={null}
        width={900}
        centered
        destroyOnClose
      >
        {currentOrder && (
          <div style={{ maxHeight: '65vh', overflowY: 'auto', paddingRight: 8, paddingTop: 8 }}>
            {/* 基本信息 */}
            <Descriptions title="基本信息" bordered column={2} size="small">
              <Descriptions.Item label="订单编号">{currentOrder.orderNo}</Descriptions.Item>
              <Descriptions.Item label="订单状态">
                <Tag color={getStatusColor(currentOrder.status)} bordered={false}>{currentOrder.status}</Tag>
              </Descriptions.Item>
              <Descriptions.Item label="创建时间(UTC)">{currentOrder.createTimeUTC}</Descriptions.Item>
              <Descriptions.Item label="创建时间(Local)">{currentOrder.createTimeLocal}</Descriptions.Item>
              <Descriptions.Item label="应用方向">{renderTagLines(getAppDirectionLabels(currentOrder), APP_DIRECTION_COLORS)}</Descriptions.Item>
              <Descriptions.Item label="订单来源">{renderTagLines(getOrderSourceLabels(currentOrder.orderSource), ORDER_SOURCE_COLORS)}</Descriptions.Item>
              <Descriptions.Item label="收款方式">{currentOrder.paymentMethod}</Descriptions.Item>
            </Descriptions>

            <Divider />

            {/* 应用信息 */}
            <Descriptions title="应用信息" bordered column={2} size="small">
              <Descriptions.Item label="应用名称">{currentOrder.appName}</Descriptions.Item>
              <Descriptions.Item label="AppID">{currentOrder.appId}</Descriptions.Item>
              <Descriptions.Item label="平台终端">{currentOrder.appPlatform}</Descriptions.Item>
              <Descriptions.Item label="上架区域">{currentOrder.location || '国内'}</Descriptions.Item>
            </Descriptions>

            <Divider />

            {/* 企业信息 */}
            <Descriptions title="企业信息" bordered column={2} size="small">
              <Descriptions.Item label="App所属企业">
                {currentOrder.appEnterprise}<br />
                <Text type="secondary" style={{ fontSize: 12 }}>ID: {currentOrder.appEnterpriseId}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="设备所属企业">
                {currentOrder.deviceEnterprise}<br />
                <Text type="secondary" style={{ fontSize: 12 }}>ID: {currentOrder.deviceEnterpriseId}</Text>
              </Descriptions.Item>
            </Descriptions>

            <Divider />

            {/* 产品与设备信息 */}
            <Descriptions title="产品与设备信息" bordered column={2} size="small">
              <Descriptions.Item label="产品名称">{currentOrder.productName}</Descriptions.Item>
              <Descriptions.Item label="产品ID">{currentOrder.productId}</Descriptions.Item>
              <Descriptions.Item label="License" span={2}>
                <Text style={{ fontFamily: 'monospace' }}>{currentOrder.license}</Text>
              </Descriptions.Item>
            </Descriptions>

            <Divider />

            {/* 用户信息 */}
            <Descriptions title="用户信息" bordered column={2} size="small">
              <Descriptions.Item label="用户ID">
                <Text style={{ fontFamily: 'monospace', fontSize: 12 }}>{currentOrder.userId}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="用户账号">{currentOrder.userAccount || '-'}</Descriptions.Item>
              <Descriptions.Item label="注册时间" span={2}>{currentOrder.userRegTime || '-'}</Descriptions.Item>
            </Descriptions>

            <Divider />

            {/* 套餐信息 */}
            <Descriptions title="套餐信息" bordered column={2} size="small">
              <Descriptions.Item label="套餐名称">{currentOrder.packageName}</Descriptions.Item>
              <Descriptions.Item label="套餐ID">{currentOrder.packageId}</Descriptions.Item>
              <Descriptions.Item label="订阅类型">
                <Tag color={currentOrder.subscriptionType === '订阅制' ? 'blue' : 'default'} bordered={false}>
                  {currentOrder.subscriptionType}
                </Tag>
              </Descriptions.Item>
              <Descriptions.Item label="服务时长">{currentOrder.duration}</Descriptions.Item>
              <Descriptions.Item label="是否首次订阅">{currentOrder.isFirstSubscription}</Descriptions.Item>
              <Descriptions.Item label="套餐状态">
                <Tag
                  color={currentOrder.packageStatus === '生效中' ? 'success' : currentOrder.packageStatus === '待生效' ? 'processing' : 'default'}
                  bordered={false}
                >
                  {currentOrder.packageStatus}
                </Tag>
              </Descriptions.Item>
            </Descriptions>

            <Divider />

            {/* 套餐服务明细 */}
            <div style={{ marginBottom: 16, fontWeight: 'bold', fontSize: 16, color: 'rgba(0,0,0,0.85)' }}>套餐服务</div>
            <Table
              size="small"
              bordered
              pagination={false}
              columns={[
                { title: '服务ID', dataIndex: 'serviceId', key: 'serviceId', width: 120 },
                { title: '服务名称', dataIndex: 'serviceName', key: 'serviceName', width: 200 },
                { title: '服务类型', dataIndex: 'serviceType', key: 'serviceType', width: 140 },
                { title: '平台成本', dataIndex: 'platformCost', key: 'platformCost' },
              ]}
              dataSource={currentOrder.packageServices || []}
              locale={{ emptyText: '暂无服务明细' }}
              style={{ marginBottom: 24 }}
            />

            <Divider />

            {/* 支付信息 */}
            <Descriptions title="支付信息" bordered column={2} size="small">
              <Descriptions.Item label="支付渠道">{currentOrder.payChannel}</Descriptions.Item>
              <Descriptions.Item label="支付币种">{currentOrder.payCurrency}</Descriptions.Item>
              <Descriptions.Item label="支付金额">
                <Text strong>{currentOrder.payCurrency === '人民币' ? '¥' : '$'}{currentOrder.payAmount}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="支付单号">
                <Text style={{ fontFamily: 'monospace', fontSize: 12 }}>{currentOrder.payOrderNo}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="支付时间(UTC)">{currentOrder.bizPayTimeUTC}</Descriptions.Item>
              <Descriptions.Item label="支付时间(Local)">{currentOrder.bizPayTimeLocal}</Descriptions.Item>
            </Descriptions>

            <Divider />

            {/* 退款记录 */}
            <div style={{ marginBottom: 16, fontWeight: 'bold', fontSize: 16, color: 'rgba(0,0,0,0.85)' }}>退款记录</div>
            {currentOrder.refundAmount === '0.00' ? (
              <div style={{ color: '#999', padding: '16px 0', textAlign: 'center', marginBottom: 24 }}>暂无退款记录</div>
            ) : (
              <Table
                size="small"
                bordered
                pagination={false}
                columns={[
                  { title: '退款方式', dataIndex: 'refundMethod', key: 'refundMethod', width: 120 },
                  { title: '退款币种', dataIndex: 'refundCurrency', key: 'refundCurrency', width: 100 },
                  { title: '退款金额', dataIndex: 'refundAmount', key: 'refundAmount', width: 120 },
                  { title: '退款时间', key: 'refundTime', width: 200,
                    render: () => (
                      <div style={{ fontSize: 12 }}>
                        <div>{currentOrder.refundTimeUTC} (UTC)</div>
                        <div style={{ color: '#999' }}>{currentOrder.refundTimeLocal} (Local)</div>
                      </div>
                    ),
                  },
                ]}
                dataSource={[{ key: 'refund1', refundMethod: currentOrder.refundMethod, refundCurrency: currentOrder.refundCurrency, refundAmount: currentOrder.refundAmount }]}
                style={{ marginBottom: 24 }}
              />
            )}

            <Divider />

            {/* 关联订单 */}
            <div style={{ marginBottom: 16, fontWeight: 'bold', fontSize: 16, color: 'rgba(0,0,0,0.85)' }}>关联订单</div>
            <Table
              size="small"
              bordered
              pagination={false}
              columns={[
                { title: '订单编号', dataIndex: 'orderNo', key: 'orderNo', width: 200, render: (text) => <Text style={{ fontFamily: 'monospace', fontSize: 12 }}>{text}</Text> },
                { title: '状态', dataIndex: 'status', key: 'status', width: 90, render: (s) => <Tag color={getStatusColor(s)} bordered={false}>{s}</Tag> },
                { title: '支付时间', dataIndex: 'payTimeUtc', key: 'payTimeUtc', width: 160 },
                { title: '支付币种', dataIndex: 'payCurrency', key: 'payCurrency', width: 90 },
                { title: '支付金额', dataIndex: 'payAmount', key: 'payAmount', width: 100 },
                { title: '订阅类型', dataIndex: 'subscriptionType', key: 'subscriptionType', width: 90 },
                { title: '创建时间', dataIndex: 'createTimeUtc', key: 'createTimeUtc', width: 160 },
              ]}
              dataSource={currentOrder.relatedOrders || []}
              locale={{ emptyText: '暂无关联订单' }}
            />
          </div>
        )}
      </Modal>
    </div>
  );
};

export default OrderQuery;
